import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ICON_PATH } from '@app/shared/modules/icon/icon.constants';
import { AuthEndpoint } from '@app/constants/auth-constants';
import { Endpoint, SERVER_URL } from '@app/constants/endpoints.constants';

@Injectable()
export class ServerUrlInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (
      !request.url.includes(ICON_PATH) &&
      !request.url.includes(AuthEndpoint.Token) &&
      !request.url.includes(Endpoint.Config)
    ) {
      request = request.clone({
        url: SERVER_URL.concat(request.url)
      });
    }
    return next.handle(request);
  }
}
